// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__371W0","header":"Messages_header__3EONm"};